import { http } from '../helpers/axiosHelper';

export default {
   async get() {
      return await http.get(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/system-notification`).then((response) => response.data);
   },
};
